import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import "./CheckoutPage.css"
function CheckoutPage() {
  const navigate = useNavigate();
const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);

const [selectedCountry, setSelectedCountry] = useState("");
const [selectedState, setSelectedState] = useState("");
const [selectedCity, setSelectedCity] = useState("");
const [payment, setPayment] = useState("razorpay");
const [checkoutData, setCheckoutData] = useState(null);
const [checkoutLoading, setCheckoutLoading] = useState(true);
const [paymentLoading, setPaymentLoading] = useState(false);
const [shippingLoading, setShippingLoading] = useState(false);
const [shippingOptions, setShippingOptions] = useState([]);
const [selectedCourierId, setSelectedCourierId] = useState("");
const [shippingError, setShippingError] = useState("");
const [popup, setPopup] = useState({
  show: false,
  type: "",
  title: "",
  message: "",
});
const [formData, setFormData] = useState({
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  company_name: "",
  address: "",
  apartment: "",
  pincode: "",
});

const selectedShippingOption =
  shippingOptions.find(
    (option) => String(option.courier_id) === String(selectedCourierId)
  ) || null;

const shippingAmount = selectedShippingOption
  ? Number(selectedShippingOption.shipping_rate || 0)
  : 0;

const orderTotal = Number(checkoutData?.cart_total || 0) + shippingAmount;

const formatINR = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

useEffect(() => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");

  if (storedUser) {
    setFormData((prev) => ({
      ...prev,
      first_name: storedUser.fname || "",
      last_name: storedUser.lname || "",
      email: storedUser.email || "",
      phone: storedUser.phone || "",
    }));
  }
}, []);
const getCheckoutUserPayload = () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const userId = storedUser?.id || "";
  const guestId = localStorage.getItem("guest_id") || "";

  return userId
    ? { user_id: Number(userId) }
    : { guest_id: guestId };
};

const fetchShippingOptions = async (pin = formData.pincode) => {
  const cleanPincode = String(pin || "").trim();

  if (!/^\d{6}$/.test(cleanPincode)) {
    setShippingOptions([]);
    setSelectedCourierId("");
    setShippingError("");
    return;
  }

  try {
    setShippingLoading(true);
    setShippingError("");

    const res = await fetch(
      "https://aethearia.store/superadmin/api/check-shipping",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...getCheckoutUserPayload(),
          pincode: Number(cleanPincode),
        }),
      }
    );

    const data = await res.json();

    console.log("Check Shipping Response:", data);

    if (data.status && data.shipping_options?.length) {
      const sortedOptions = [...data.shipping_options].sort(
        (a, b) => Number(a.shipping_rate || 0) - Number(b.shipping_rate || 0)
      );

      setShippingOptions(sortedOptions);
      setSelectedCourierId(String(sortedOptions[0].courier_id));
    } else {
      setShippingOptions([]);
      setSelectedCourierId("");
      setShippingError(data.message || "Shipping is not available for this PIN code.");
    }
  } catch (error) {
    console.error("Check shipping error:", error);
    setShippingOptions([]);
    setSelectedCourierId("");
    setShippingError("Unable to check shipping. Please try again.");
  } finally {
    setShippingLoading(false);
  }
};


const verifyPayment = async (response) => {
  try {
    const res = await fetch(
      "https://aethearia.store/superadmin/api/verify-payment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        }),
      }
    );

    const data = await res.json();

    console.log("Verify Payment Response:", data);

    if (data.status) {
      setPopup({
        show: true,
        type: "success",
        title: "Payment Successful",
        message: data.message || "Your order has been placed successfully.",
      });

      // optional: redirect after popup
      // setTimeout(() => navigate("/thank-you"), 2000);

      return true;
    } else {
      setPopup({
        show: true,
        type: "cancel",
        title: "Payment Verification Failed",
        message: data.message || "Payment verification failed. Please try again.",
      });

      return false;
    }
  } catch (error) {
    console.error("Verify payment error:", error);

    setPopup({
      show: true,
      type: "cancel",
      title: "Payment Error",
      message: "Payment verification failed. Please contact support.",
    });

    return false;
  }
};
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
};
const handleProceedToPayment = async () => {
  try {
    if (!checkoutData?.cart_items?.length) {
      alert("Your cart is empty");
      return;
    }

    if (!formData.first_name.trim()) {
      alert("Please enter first name");
      return;
    }

    if (!formData.last_name.trim()) {
      alert("Please enter last name");
      return;
    }

    if (!formData.email.trim()) {
      alert("Please enter email");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter phone number");
      return;
    }

    if (!selectedCountry || !selectedState || !selectedCity) {
      alert("Please select country, state and city");
      return;
    }

    if (!formData.address.trim()) {
      alert("Please enter address");
      return;
    }

    if (!/^\d{6}$/.test(String(formData.pincode).trim())) {
      alert("Please enter a valid 6-digit PIN code");
      return;
    }

    if (shippingLoading) {
      alert("Please wait while shipping is being calculated");
      return;
    }

    if (!selectedShippingOption) {
      alert("Please check and select a shipping option");
      return;
    }

    if (!payment) {
      alert("Please select payment method");
      return;
    }

    setPaymentLoading(true);

    const payload = {
      ...getCheckoutUserPayload(),
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone: formData.phone,
      company_name: formData.company_name,
      country_id: Number(selectedCountry),
      state_id: Number(selectedState),
      city_id: Number(selectedCity),
      address: formData.address,
      apartment: formData.apartment,
      pincode: formData.pincode,
      shipping_charge: Number(selectedShippingOption.shipping_rate || 0),
      courier_id: Number(selectedShippingOption.courier_id),
      payment_method: "razorpay",
    };

    console.log("Proceed Payment Payload:", payload);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/proceed-to-payment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Proceed Payment Response:", data);

    if (!data.status) {
      alert(data.message || "Payment failed");
      return;
    }

    if (payment === "razorpay") {
      const razorpayLoaded = await loadRazorpayScript();

      if (!razorpayLoaded) {
        alert("Razorpay failed to load. Please try again.");
        return;
      }

   const payableAmount = Number(data.grand_total || data.amount || orderTotal || 0);

   const options = {
  key: data.razorpay_key,
  amount: Math.round(payableAmount * 100),
  currency: data.currency || "INR",
  name: "Aethearia Candle",
  description: data.order_number,
  order_id: data.razorpay_order_id,

  handler: async function (response) {
    console.log("Razorpay Success:", response);

    await verifyPayment(response);
  },

  modal: {
    ondismiss: function () {
      setPopup({
        show: true,
        type: "cancel",
        title: "Payment Cancelled",
        message: "You cancelled the payment. Your order is not completed.",
      });
    },
  },

  prefill: {
    name: `${formData.first_name} ${formData.last_name}`,
    email: formData.email,
    contact: formData.phone,
  },

  theme: {
    color: "#4c144e",
  },
};

      const razorpay = new window.Razorpay(options);
      razorpay.on("payment.failed", function (response) {
  console.log("Payment Failed:", response.error);

  setPopup({
    show: true,
    type: "cancel",
    title: "Payment Failed",
    message:
      response.error?.description ||
      "Your payment could not be completed. Please try again.",
  });
});

      razorpay.open();
    } else {
      alert(data.message || "Order placed successfully");
      // navigate("/thank-you");
    }
  } catch (error) {
    console.error("Proceed payment error:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setPaymentLoading(false);
  }
};
const heroURL =
  "https://aethearia.store/superadmin/uploads/products/Hero/";

const variantURL =
  "https://aethearia.store/superadmin/uploads/products/Varient/";
const fetchCheckoutDetails = async () => {
  try {
    setCheckoutLoading(true);

    const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    const userId = storedUser?.id;
    const guestId = localStorage.getItem("guest_id");

    if (!userId && !guestId) {
      setCheckoutData(null);
      return;
    }

    const requestBody = userId
      ? { user_id: userId }
      : { guest_id: guestId };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/getCheckoutDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    const data = await res.json();

  if (data.status) {
  const sortedCartItems = [...(data.cart_items || [])].sort(
    (a, b) => Number(b.cart_id) - Number(a.cart_id)
  );

  setCheckoutData({
    ...data,
    cart_items: sortedCartItems,
  });

  if (data.payment_methods?.length > 0) {
    const razorpay = data.payment_methods.find(
      (method) => method.id === "razorpay"
    );

    setPayment(razorpay ? "razorpay" : data.payment_methods[0].id);
  }
} else {
      setCheckoutData(null);
    }
  } catch (error) {
    console.error("Checkout details fetch error:", error);
  } finally {
    setCheckoutLoading(false);
  }
};

useEffect(() => {
  fetchCheckoutDetails();
}, []);

useEffect(() => {
  const cleanPincode = String(formData.pincode || "").trim();

  if (!checkoutData?.cart_items?.length) {
    return;
  }

  if (cleanPincode.length === 0) {
    setShippingOptions([]);
    setSelectedCourierId("");
    setShippingError("");
    return;
  }

  if (cleanPincode.length < 6) {
    setShippingOptions([]);
    setSelectedCourierId("");
    setShippingError("");
    return;
  }

  const timer = setTimeout(() => {
    fetchShippingOptions(cleanPincode);
  }, 500);

  return () => clearTimeout(timer);
}, [formData.pincode, checkoutData?.cart_items?.length]);
const deleteCartItem = async (cart_id) => {
  const oldCheckoutData = checkoutData;

  const updatedItems = checkoutData.cart_items.filter(
    (item) => Number(item.cart_id) !== Number(cart_id)
  );

  const updatedTotal = updatedItems.reduce((total, item) => {
    return total + Number(item.final_price || 0) * Number(item.quantity || 1);
  }, 0);

  const updatedTotalItems = updatedItems.reduce((total, item) => {
    return total + Number(item.quantity || 1);
  }, 0);

  // instant checkout UI update
  setCheckoutData((prev) => ({
    ...prev,
    cart_items: updatedItems,
    cart_total: updatedTotal,
    total_items: updatedTotalItems,
  }));

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        cartCount: updatedItems.length,
      },
    })
  );

  try {
    const res = await fetch(
      "https://aethearia.store/superadmin/api/delete-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...getCheckoutUserPayload(),
          cart_id: cart_id,
        }),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchCheckoutDetails();

      window.dispatchEvent(new Event("cartWishlistUpdated"));
    } else {
      setCheckoutData(oldCheckoutData);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            cartCount: oldCheckoutData?.cart_items?.length || 0,
          },
        })
      );

      alert(data.message || "Delete failed");
    }
  } catch (err) {
    console.error("Delete cart error:", err);

    setCheckoutData(oldCheckoutData);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          cartCount: oldCheckoutData?.cart_items?.length || 0,
        },
      })
    );

    alert("Something went wrong while removing item");
  }
};
useEffect(() => {
  const fetchCountries = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/getCountries"
      );
      const data = await res.json();

      if (data.status) {
        setCountries(data.data || []);

        const india = data.data.find((item) => item.name === "India");

        if (india) {
          setSelectedCountry(india.id);
        }
      }
    } catch (error) {
      console.error("Country fetch error:", error);
    }
  };

  fetchCountries();
}, []);

useEffect(() => {
  if (!selectedCountry) return;

  const fetchStates = async () => {
    try {
      const res = await fetch(
        `https://aethearia.store/superadmin/api/getStates/${selectedCountry}`
      );
      const data = await res.json();

      if (data.status) {
        setStates(data.data || []);

        const maharashtra = data.data.find(
          (item) => item.name === "Maharashtra"
        );

        if (maharashtra) {
          setSelectedState(maharashtra.id);
        } else if (data.data.length > 0) {
          setSelectedState(data.data[0].id);
        }
      }
    } catch (error) {
      console.error("State fetch error:", error);
    }
  };

  fetchStates();
}, [selectedCountry]);

useEffect(() => {
  if (!selectedState) return;

  const fetchCities = async () => {
    try {
      const res = await fetch(
        `https://aethearia.store/superadmin/api/getCities/${selectedState}`
      );
      const data = await res.json();

      if (data.status) {
        setCities(data.data || []);

        if (data.data.length > 0) {
          setSelectedCity(data.data[0].id);
        }
      }
    } catch (error) {
      console.error("City fetch error:", error);
    }
  };

  fetchCities();
}, [selectedState]);
return(
<>
<style>{`

.checkout-page{
  min-height:100vh;
  padding-top:120px;
  color:#2d241a;
}

/* layout */
.checkout-wrap{
  display:grid;
  grid-template-columns:1fr 510px;
  align-items:start;
}

/* LEFT */
.checkout-left{
  padding:50px 120px;
}

.checkout-logo{
font-size: 30px;
font-weight: 100;
margin: 0 0 12px;
color: #4c144e;
}

/* section */
.checkout-section{
  margin-bottom:35px;
}

.checkout-section h3{
  font-size:14px;
  margin-bottom:18px;
  font-weight:700;
}

/* inputs */
.checkout-input,
.checkout-select{
  width:100%;
  height:52px;

  border:1px solid #ddd2c2;
  background:transparent;

  padding:0 16px;
  margin-bottom:14px;

  font-size:14px;
  box-sizing:border-box;
}

.double-row{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:14px;
}

.triple-row{
  display:grid;
  grid-template-columns:1fr 1fr 1fr;
  gap:14px;
}

/* checkbox */
.check-row{
  display:flex;
  align-items:center;
  gap:10px;
  font-size:14px;
  margin-top:6px;
}

/* payment */
.payment-box{
  border:1px solid #ddd2c2;
  background:#fff;
  margin-bottom:14px;
}

.payment-option{
  padding:18px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  cursor:pointer;
}

.payment-left{
  display:flex;
  align-items:center;
  gap:12px;
}

.payment-info{
  padding:18px;
  border-top:1px solid #eee;
  background:#faf7f2;
  font-size:14px;
  color:#6c6155;
}

.shipping-box{
  border:1px solid #ddd2c2;
  background:#fff;
  padding:14px;
  margin:-4px 0 16px;
}

.shipping-box-title{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  font-size:13px;
  font-weight:700;
  color:#2d241a;
  margin-bottom:10px;
}

.shipping-check-btn{
  border:1px solid #4c144e;
  background:#fff;
  color:#4c144e;
  border-radius:4px;
  padding:7px 12px;
  font-size:12px;
  cursor:pointer;
}

.shipping-check-btn:disabled{
  opacity:0.6;
  cursor:not-allowed;
}

.shipping-message{
  font-size:13px;
  color:#7a6f63;
  margin:0;
}

.shipping-error{
  color:#b00020;
}

.shipping-option{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:12px 0;
  border-top:1px solid #eee;
  cursor:pointer;
}

.shipping-option:first-of-type{
  border-top:none;
}

.shipping-option-left{
  display:flex;
  align-items:flex-start;
  gap:10px;
}

.shipping-option-name{
  display:block;
  font-size:14px;
  color:#2d241a;
  font-weight:600;
}

.shipping-option-meta{
  display:block;
  font-size:12px;
  color:#7a6f63;
  margin-top:3px;
}

.shipping-option-price{
  font-size:14px;
  color:#2d241a;
  font-weight:700;
  white-space:nowrap;
}

/* button */
.pay-btn{
  width:20%;
  height:40px;
  border-radius:5px;
  background:#4c144e;
  color:#fff;
  border:none;
  font-size:14px;
  cursor:pointer;
  margin-top:25px;
}



/* product */
.checkout-product{
  display:flex;
  gap:15px;
  margin-bottom:30px;
}

.checkout-product img{
  width:80px;
  height:95px;
  object-fit:cover;
}

.product-meta h4{
  margin:0 0 8px;
  font-size:14px;
  font-weight:500;
}

.product-meta p{
  margin:0;
  color:#7a6f63;
  font-size:14px;
}

/* summary */
.summary-row{
  display:flex;
  justify-content:space-between;
  margin:16px;

  font-size:14px;
}

.summary-total{
  display:flex;
  justify-content:space-between;

  padding-top:20px;
  margin:20px 16px 0 16px ;

  border-top:1px solid #ddd2c2;

  font-size:24px;
    font-family: Assistant, sans-serif;
}

/* MOBILE */
@media(max-width:900px){

  .checkout-wrap{
    grid-template-columns:1fr;
  }

  .checkout-left{
    padding:30px 20px;
  }



  .double-row,
  .triple-row{
    grid-template-columns:1fr;
  }

  .checkout-logo{
    font-size:20px;
  }
    .pay-btn{
  width:40%;
  height:40px;
  border-radius:5px;
  background:#4c144e;
  color:#fff;
  border:none;
  font-size:14px;
  cursor:pointer;
  margin-top:25px;
}

}
  .payment-icons{
  display:flex;
  align-items:center;
  gap:8px;
}

.payment-icons img{
  width:38px;
  height:24px;
  object-fit:contain;

  background:#fff;
  border:1px solid #ddd;
  border-radius:4px;

}

.plus-more{
  font-size:12px;
  color:#6c6155;
  font-weight:500;
   background:#fff;
  border:1px solid #ddd;
  border-radius:4px;
  padding:4px 7px
}
  .checkout-top{
  display:flex;
  justify-content:space-between;
  align-items:center;

  margin-bottom:40px;
}

.signin-btn{
  background:none;
  border:none;

  color:#2d241a;
  font-size:14px;

  cursor:pointer;
  text-decoration:underline;
}
  .checkout-remove-btn {
  background: transparent;
  border: none;
  color: #4c144e;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.checkout-remove-btn:hover {
  color: #111;
}
  .product-price{
display: inline-block;
margin-top: 0 !important;
font-size: 14px;
color: #2d241a;
}
.checkout-right {
  background: #f8f3ec;
  padding: 45px 45px 45px 35px;
  position: sticky;
  top: 120px;
  height: auto;
  overflow: hidden;
}

.checkout-cart-table {
  width: 100%;
}

.checkout-cart-head {
  display: grid;
  grid-template-columns: 1fr 45px 95px 60px;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #ddd2c2;
  font-size: 12px;
  color: #7a6f63;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.checkout-cart-head span:nth-child(2),
.checkout-cart-head span:nth-child(3) {
  text-align: right;
}

.checkout-products-scroll {
  display: flex;
  flex-direction: column;
  gap: 14px;

  max-height: 420px;
  overflow-y: auto;
  padding-right: 8px;

  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

.checkout-products-scroll::-webkit-scrollbar {
  width: 5px;
}

.checkout-products-scroll::-webkit-scrollbar-track {
  background: #eadcc9;
  border-radius: 20px;
}

.checkout-products-scroll::-webkit-scrollbar-thumb {
  background: #4c144e;
  border-radius: 20px;
}
.checkout-cart-row {
  display: grid;
  grid-template-columns: 1fr 45px 95px 60px;
  gap: 12px;
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(221, 210, 194, 0.7);
}

.checkout-product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.checkout-img-box {
  width: 58px;
  height: 70px;
  flex: 0 0 58px;
  border: 1px solid #eadcc9;
  background: #fff;
  overflow: hidden;
}

.checkout-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.checkout-product-name {
  min-width: 0;
}

.checkout-product-name h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #2d241a;
  line-height: 1.4;
}

.checkout-product-qty {
  text-align: right;
  font-size: 13px;
  color: #7a6f63;
}

.checkout-product-price {
  text-align: right;
  font-size: 14px;
  color: #2d241a;
  font-weight: 500;
  white-space: nowrap;
}

.checkout-remove-btn {
  background: transparent;
  border: none;
  color: #4c144e;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-align: right;
}

.checkout-remove-btn:hover {
  color: #111;
}


@media(max-width:900px){
.checkout-right {
  padding: 30px 20px;
  border-left: none;
  border-top: 1px solid #ddd2c2;
  position: static;
  max-height: none;
  overflow: visible;
}

.checkout-cart-head {
  grid-template-columns: 1fr 35px 80px;
}

.checkout-cart-head span:last-child {
  display: none;
}

.checkout-cart-row {
  grid-template-columns: 1fr 35px 80px;
  align-items: start;
}

.checkout-remove-btn {
  grid-column: 1 / -1;
  text-align: left;
  margin-left: 70px;
}

.checkout-products-scroll.has-scroll {
  max-height: 480px;
}
}
@media(max-width:900px) {


  .checkout-products-scroll {
    max-height: 430px;
    overflow-y: auto;
  }
}
  .checkout-products-scroll {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 6px;

  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #4c144e transparent;
}

.checkout-products-scroll::-webkit-scrollbar {
  width: 1px; /* thin scrollbar */
}

.checkout-products-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.checkout-products-scroll::-webkit-scrollbar-thumb {
  background: #4c144e;
  border-radius: 20px;
}

.checkout-products-scroll::-webkit-scrollbar-thumb:hover {
  background: #2d0b2f;
}
  @media (max-width: 900px) {
  .checkout-page {
    overflow: visible;
    padding-top:65px;
  }

  .checkout-wrap {
    grid-template-columns: 1fr;
    height: auto;
  }

  .checkout-left {
    height: auto;
    overflow: visible;
    padding: 30px 20px;
  }

  .checkout-right {
    position: static;
    height: auto;
    max-height: none;
    overflow: visible;
    padding: 30px 20px;
    border-top: 1px solid #ddd2c2;
  }

  .checkout-products-scroll {
    max-height: 430px;
    overflow-y: auto;
  }
}
  @media (max-width: 900px) {
  .checkout-cart-head,
  .checkout-cart-row {
    grid-template-columns: minmax(0, 0.95fr) 30px 72px 48px;
    gap: 6px;
    align-items: center;
  }

  .checkout-cart-head span:nth-child(2),
  .checkout-cart-head span:nth-child(3),
  .checkout-cart-head span:nth-child(4) {
    display: block;
    text-align: right;
  }

  .checkout-product-info {
    min-width: 0;
    gap: 7px;
  }

  .checkout-img-box {
    width: 42px;
    height: 52px;
    flex: 0 0 42px;
  }

  .checkout-product-name {
    min-width: 0;
  }

  .checkout-product-name h4 {
    font-size: 12px;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .checkout-product-qty {
    font-size: 12px;
    text-align: right;
  }

  .checkout-product-price {
    font-size: 12px;
    text-align: right;
    margin-left: 5px;
    white-space: nowrap;
  }

  .checkout-remove-btn {
    grid-column: auto;
    margin-left: 19px;
    font-size: 14px;
    text-align: right;
    white-space: nowrap;
  }
}
  @media (max-width: 900px) {
  .checkout-cart-head,
  .checkout-cart-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 35px 78px 55px;
    column-gap: 6px;
    align-items: center;
  }

  .checkout-cart-head span {
    display: block;
    min-width: 0;
  }

  .checkout-cart-head span:first-child {
    text-align: left;
  }

  .checkout-cart-head span:nth-child(2),
  .checkout-cart-head span:nth-child(3),
  .checkout-cart-head span:nth-child(4) {
    text-align: right;
  }

  .checkout-product-info {
    min-width: 0;
    gap: 7px;
  }

  .checkout-img-box {
    width: 42px;
    height: 52px;
    flex: 0 0 42px;
  }

  .checkout-product-name {
    min-width: 0;
  }

  .checkout-product-name h4 {
    margin: 0;
    font-size: 12px;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .checkout-product-qty {
    width: 100%;
    font-size: 12px;
    text-align: right;
  }

  .checkout-product-price {
    width: 100%;
    margin: 0;
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
  }

  .checkout-remove-btn {
    grid-column: auto;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    margin-left: 6px;
  }
     .checkout-top{

  margin-bottom:10px;
}
}
`}</style>

<Header/>

<section className="checkout-page">

<div className="checkout-wrap">

  {/* LEFT */}
  <div className="checkout-left">

    <div className="checkout-top">

  <div className="checkout-logo">
    Aethearia Candle
  </div>

  {!localStorage.getItem("user") && (
    <Link
      to="/login"
      className="signin-btn"
    >
      Sign in
    </Link>
  )}

</div>

    {/* CONTACT */}
    <div className="checkout-section">

      <h3>Contact</h3>

      <input
        className="checkout-input"
        placeholder="Email"
        value={formData.email}
        onChange={(e) =>
          setFormData({ ...formData, email: e.target.value })
        }
      />

      <div className="check-row">
        <input type="checkbox"/>
        <span>Email me with news and offers</span>
      </div>

    </div>

    {/* DELIVERY */}
    <div className="checkout-section">

      <h3>Delivery</h3>

     

      <div className="double-row">

          <input
        className="checkout-input"
        placeholder="First name"
        value={formData.first_name}
        onChange={(e) =>
          setFormData({ ...formData, first_name: e.target.value })
        }
      />

        <input
        className="checkout-input"
        placeholder="Last name"
        value={formData.last_name}
        onChange={(e) =>
          setFormData({ ...formData, last_name: e.target.value })
        }
      />

      </div>

      <select
        className="checkout-select"
        value={selectedCountry}
        onChange={(e) => {
          setSelectedCountry(e.target.value);
          setSelectedState("");
          setSelectedCity("");
          setStates([]);
          setCities([]);
        }}
      >
        <option value="">Select Country</option>

        {countries.map((country) => (
          <option key={country.id} value={country.id}>
            {country.name}
          </option>
        ))}
    </select>

    <div className="triple-row">

  <select
    className="checkout-select"
    value={selectedState}
    onChange={(e) => {
      setSelectedState(e.target.value);
      setSelectedCity("");
      setCities([]);
    }}
  >
    <option value="">Select State</option>

    {states.map((state) => (
      <option key={state.id} value={state.id}>
        {state.name}
      </option>
    ))}
  </select>
    <select
    className="checkout-select"
    value={selectedCity}
    onChange={(e) => setSelectedCity(e.target.value)}
  >
    <option value="">Select City</option>

    {cities.map((city) => (
      <option key={city.id} value={city.id}>
        {city.name}
      </option>
    ))}
  </select>
        <input
          className="checkout-input"
          placeholder="PIN code"
          value={formData.pincode}
          maxLength={6}
          inputMode="numeric"
          onChange={(e) =>
            setFormData({
              ...formData,
              pincode: e.target.value.replace(/\D/g, "").slice(0, 6),
            })
          }
        />

</div>

      <div className="shipping-box">
        <div className="shipping-box-title">
          <span>Shipping options</span>

          <button
            type="button"
            className="shipping-check-btn"
            onClick={() => fetchShippingOptions()}
            disabled={shippingLoading || !/^\d{6}$/.test(String(formData.pincode).trim())}
          >
            {shippingLoading ? "Checking..." : "Check"}
          </button>
        </div>

        {!formData.pincode ? (
          <p className="shipping-message">Enter your PIN code to view shipping charges.</p>
        ) : String(formData.pincode).length < 6 ? (
          <p className="shipping-message">Enter a valid 6-digit PIN code.</p>
        ) : shippingLoading ? (
          <p className="shipping-message">Checking available courier partners...</p>
        ) : shippingError ? (
          <p className="shipping-message shipping-error">{shippingError}</p>
        ) : shippingOptions.length > 0 ? (
          shippingOptions.map((option) => (
            <label className="shipping-option" key={option.courier_id}>
              <div className="shipping-option-left">
                <input
                  type="radio"
                  name="shipping"
                  checked={String(selectedCourierId) === String(option.courier_id)}
                  onChange={() => setSelectedCourierId(String(option.courier_id))}
                />

                <span>
                  <span className="shipping-option-name">
                    {option.courier_name}
                  </span>

                  {/* <span className="shipping-option-meta">
                    Delivery in {option.estimated_days} days • Rating {option.rating}
                  </span> */}
                </span>
              </div>

              <span className="shipping-option-price">
                {formatINR(option.shipping_rate)}
              </span>
            </label>
          ))
        ) : (
          <p className="shipping-message">No shipping option selected yet.</p>
        )}
      </div>


      <input
        className="checkout-input"
        placeholder="Phone"
        value={formData.phone}
        onChange={(e) =>
          setFormData({ ...formData, phone: e.target.value })
        }
      />
       <input
        className="checkout-input"
        placeholder="Address"
        value={formData.address}
        onChange={(e) =>
          setFormData({ ...formData, address: e.target.value })
        }
      />
      <div className="double-row">
  <input
    className="checkout-input"
    placeholder="Company (optional)"
    value={formData.company_name}
    onChange={(e) =>
      setFormData({ ...formData, company_name: e.target.value })
    }
  />

  <input
    className="checkout-input"
    placeholder="Apartment, suite, etc. (optional)"
    value={formData.apartment}
    onChange={(e) =>
      setFormData({ ...formData, apartment: e.target.value })
    }
  />
</div>

      {/* <div className="check-row">
        <input type="checkbox"/>
        <span>Save this information for next time</span>
      </div> */}

    </div>

    {/* PAYMENT */}
    <div className="checkout-section">

      <h3>Payment</h3>
<div className="payment-box">
  <div className="payment-option" onClick={() => setPayment("razorpay")}>
    <div className="payment-left">
      <input
        type="radio"
        checked={payment === "razorpay"}
        readOnly
      />

      <span>Razorpay Secure (UPI, Cards, Wallets)</span>
    </div>

    <div className="payment-icons">
      <img
        src={process.env.PUBLIC_URL + "/images/upi.svg"}
        alt="upi"
      />

      <img
        src={process.env.PUBLIC_URL + "/images/card.svg"}
        alt="card"
      />

      <img
        src={process.env.PUBLIC_URL + "/images/visa.svg"}
        alt="visa"
      />

      <span className="plus-more">18+</span>
    </div>
  </div>

  <div className="payment-info">
    You’ll be redirected to Razorpay to complete your purchase securely.
  </div>
</div>

<button
  className="pay-btn"
  onClick={handleProceedToPayment}
  disabled={paymentLoading || checkoutLoading}
>
{paymentLoading ? "Processing..." : "Pay now"}
</button>

    </div>

  </div>

  {/* RIGHT */}
<div className="checkout-right">

  {checkoutLoading ? (
    <p>Loading order summary...</p>
  ) : checkoutData?.cart_items?.length > 0 ? (
    <>
<div className="checkout-cart-table">
  <div className="checkout-cart-head">
    <span>Product</span>
    <span>Qty</span>
    <span>Price</span>
    <span>Delete</span>
  </div>

 <div className="checkout-products-scroll">
    {checkoutData.cart_items.map((item) => (
      <div className="checkout-cart-row" key={item.cart_id}>
        <div className="checkout-product-info">
          <div className="checkout-img-box">
            <img
              src={
                item.variant_image
                  ? variantURL + item.variant_image
                  : heroURL + item.hero_image
              }
              alt={item.product_name}
            />
          </div>

          <div className="checkout-product-name">
            <h4>{item.product_name}</h4>
          </div>
        </div>

        <div className="checkout-product-qty">
          {item.quantity}
        </div>

        <div className="checkout-product-price">
          ₹{Number(item.final_price).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          
        </div>

        <button
          type="button"
          className="checkout-remove-btn"
          onClick={() => deleteCartItem(item.cart_id)}
        >
          Remove
        </button>
      </div>
    ))}
  </div>
</div>

      <div className="summary-row">
        <span>Subtotal</span>
        <span>
          {formatINR(checkoutData.cart_total)}
        </span>
      </div>

      <div className="summary-row">
        <span>Total Items</span>
        <span>{checkoutData.total_items}</span>
      </div>
      <div className="summary-row">
        <span>Discount</span>
        <span>0</span>
      </div>
      <div className="summary-row">
        <span>
          Shipping
          {selectedShippingOption?.courier_name
            ? ` (${selectedShippingOption.courier_name})`
            : ""}
        </span>
        <span>
          {selectedShippingOption ? formatINR(shippingAmount) : "Enter PIN code"}
        </span>
      </div>
      

      <div className="summary-total">
        <span>Total</span>
        <span>
          {formatINR(orderTotal)}
        </span>
      </div>
    </>
  ) : (
    <p>Your cart is empty.</p>
  )}

</div>

</div>

</section>
{popup.show && (
  <div className="payment-popup-overlay">
    <div className={`payment-popup ${popup.type}`}>
      <div className="popup-icon">
        {popup.type === "success" ? "✓" : "!"}
      </div>

      <h2>{popup.title}</h2>

      <p>{popup.message}</p>

      <button
        onClick={() => {
          setPopup({
            show: false,
            type: "",
            title: "",
            message: "",
          });

          if (popup.type === "success") {
            navigate("/");
          }
        }}
      >
        OK
      </button>
    </div>
  </div>
)}
<Footer/>

</>
)
}

export default CheckoutPage;